import axios from 'axios';

let cancelRequest;

export default async (url, input, callback, downloadUrl = url) => {
  if (cancelRequest) {
    cancelRequest();
  }
  const abortController = new AbortController();
  cancelRequest = () => abortController.abort();
  try {
    const response = await axios({
      url,
      method: 'post',
      data: input,
      signal: abortController.signal,
    });
    callback(response);
    window.top.location = `${window.location.origin}/${downloadUrl.replace(/^\/+/g, '')}/${response.data.token}`;
  }
  catch (err) {
    console.error(err);
    return err.response.data.errors;
  }
};
